import React from "react";
import "flag-icon-css/css/flag-icon.css";
import "./GeoView.scss";
import cn from "classnames";

const GeoFlag = ({ code, name, isExclude }) => {
  return (
    <span
      className={cn(`flag-icon flag-icon-${code}`, {
        "flag-icon_exclude": isExclude
      })}
      title={name}
    />
  );
};

export default GeoFlag;
